import _ from 'lodash';
import * as c from './constants';
export var createAbstract = function createAbstract(data) {
  var showError = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  var searchOnSuccess = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  return function (dispatch, getState, _ref) {
    var application = _ref.application;
    return dispatch(application.post('/api/digital-abstract/create', data)).then(function (json) {
      var error = json.error;
      if (error) {
        if (showError) {
          dispatch(application.addMessage({
            type: 'error',
            message: error.error,
            params: JSON.parse(error.getJsonEncodedParams() || '{}')
          }));
        }
      } else if (searchOnSuccess) {
        dispatch(searchAbstracts({
          page: 1
        }));
      }
      return json;
    });
  };
};
export var searchAbstracts = function searchAbstracts() {
  return function (dispatch, getState, _ref2) {
    var application = _ref2.application;
    dispatch({
      type: c.ABSTRACT_SEARCH_REQUESTED
    });
    return dispatch(application.get('/api/digital-abstract/search')).then(function (json) {
      var abstracts = json.results,
        pagination = json.pagination;
      dispatch({
        type: c.ABSTRACT_SEARCH_COMPLETED,
        pagination: pagination,
        abstracts: abstracts
      });
      return abstracts;
    });
  };
};
export var updateDisplayedAbstracts = function updateDisplayedAbstracts(identities) {
  return function (dispatch, getState, _ref3) {
    var application = _ref3.application;
    return dispatch(application.get('/api/digital-abstract/search', {
      identities: identities
    })).then(function (json) {
      var abstracts = json.results;
      var keyedAbstracts = _.keyBy(abstracts, 'identity');
      dispatch({
        type: c.ABSTRACTS_UPDATED,
        abstracts: keyedAbstracts
      });
      return true;
    });
  };
};
export var removeAbstract = function removeAbstract(abstractIdentity) {
  return {
    type: c.ABSTRACT_ARCHIVED,
    abstractIdentity: abstractIdentity
  };
};
export var deleteAbstractFile = function deleteAbstractFile(fileIdentity) {
  return function (dispatch, getState, _ref4) {
    var application = _ref4.application;
    return dispatch(application.del("/api/file/delete/".concat(fileIdentity), {
      digitalAbstract: true
    }));
  };
};